var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4502 21.1004C7.0002 21.1004 6.61686 20.9421 6.3002 20.6254C5.98353 20.3087 5.8252 19.9254 5.8252 19.4754V4.60039C5.8252 4.13372 5.99186 3.73372 6.3252 3.40039C6.65853 3.06706 7.05853 2.90039 7.5252 2.90039H13.3002C15.0002 2.90039 16.4252 3.47122 17.5752 4.61289C18.7252 5.75456 19.3002 7.15872 19.3002 8.82539C19.3002 10.5087 18.7252 11.9212 17.5752 13.0629C16.4252 14.2046 15.0002 14.7754 13.3002 14.7754H9.1002V19.4754C9.1002 19.9254 8.94186 20.3087 8.6252 20.6254C8.30853 20.9421 7.91686 21.1004 7.4502 21.1004ZM9.1002 11.6254H13.2002C14.0002 11.6254 14.6669 11.3587 15.2002 10.8254C15.7335 10.2921 16.0002 9.62539 16.0002 8.82539C16.0002 8.02539 15.7335 7.35872 15.2002 6.82539C14.6669 6.29206 14.0002 6.02539 13.2002 6.02539H9.1002V11.6254Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.f2467bed6f16dc1071f28f3b04208e05.svg";
export { ForwardRef as ReactComponent };